export default {
    name: 'ToDosPage'
};
